interface LegendEntry {
  value: string;
  color?: string;
}

interface Props {
  payload?: LegendEntry[];
}

export default function ChartLegend({ payload }: Props) {
  if (!payload?.length) return null;

  return (
    <div className="flex items-center justify-end flex-wrap gap-x-5 gap-y-1 mt-3">
      {payload.map(function renderItem(entry, idx) {
        return (
          <div key={idx} className="flex items-center gap-1.5">
            <div className="w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: entry.color }} />
            <span className="text-label-xs content-base-secondary">{entry.value}</span>
          </div>
        );
      })}
    </div>
  );
}

